import ProjectPageContainer from 'src/components/ProjectPageContainer';

import ReviewersTab from './ManageProject/ReviewersTab';

export default function ProjectReviewers(): JSX.Element {
  return (
    <ProjectPageContainer>
      {(projectId, modalityLabel) => (
        <ReviewersTab projectId={projectId} modality={modalityLabel} />
      )}
    </ProjectPageContainer>
  );
}
